import interceptors from "./interceptors/index";

const format = process.env.REACT_APP_BRAND;

const getStores = () => {
    return interceptors({
      url: "/online-promocional/stores",
      method: "GET",
      params: {
        formato: format,
      }
    });
  };

const getStore = (storeId) => {
  return interceptors({
    url: `/online-promocional/stores/${storeId}`,
    method: "GET"
  })
}

const getStoresByIds = (storeIds) => {
  return interceptors({
    url: `/online-promocional/stores/ids`,
    method: "GET",
    params: { ids: storeIds.join(",") }
  })
}

export { getStores, getStore, getStoresByIds };